import React from 'react'
import {
   AIPoweredAudienceInsightsIcon,
   AIPoweredPublicInsightsIcon,
   ContinuousSupportIcon,
   CustomGovernmentSoftwareIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureCompliantIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Government Software',
      subtitle: 'Tailored Platforms for Public Services',
      description:
         'We build custom digital government platforms, including citizen portals, smart city solutions, and AI-powered public service management, ensuring efficient governance.',
      icon: <CustomGovernmentSoftwareIcon />,
   },
   {
      title: 'AI-Powered Public Insights',
      subtitle: 'Smart Data & Policy Analytics',
      description:
         'We implement AI-driven analytics tools that track public service performance, citizen behavior, and policy impact, helping governments optimize decision-making.',
      icon: <AIPoweredPublicInsightsIcon />,
   },
   {
      title: 'Secure & Compliant Systems',
      subtitle: 'Data Encryption & Cybersecurity',
      description:
         'We ensure GDPR, CCPA, and government compliance standards, integrating blockchain-based record-keeping and secure identity verification.',
      icon: <SecureCompliantIcon />,
   },
   {
      title: 'Seamless System Integration',
      subtitle: 'Public APIs & Legacy Systems',
      description:
         'We develop government platforms that seamlessly integrate with public databases, digital payment gateways, AI chatbots, and third-party services, ensuring efficient workflows.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Infrastructure',
      subtitle: 'Optimized Performance & Digital Accessibility',
      description:
         'Our cloud-powered government solutions support real-time data synchronization, multi-agency collaboration, and secure data sharing, enabling efficient digital governance.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Ongoing Maintenance & Feature Enhancements',
      description:
         'As part of our services we maintain uninterrupted technical assistance and security update services alongside platform enhancement features to deliver costly yet future-proof secure solutions to public sector organizations.',
      icon: <ContinuousSupportIcon />,
   },
]

function GovernmentWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               'Why Choose Our Government & Public Sector Software Development Services?'
            }
            desc={
               'We develop secure, scalable, and innovative government and public sector solutions that enhance governance, streamline administration, and improve public service delivery. Here’s why organizations choose Benzatine:'
            }
            cardData={featureCards}
            otherUi={true}
         />
      </>
   )
}

export default GovernmentWhyChoose
